import Loader from '@anm/components/Loader';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

import { PreviewWrapper } from '../../RightPanel/EmbedPreview/Wrapper';
import { CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH } from '@anm/styles/constants';

const embedCodeWrapperTablet = media.tablet`
    overflow: hidden;
    margin: 0 auto;
    padding-bottom: 0;
    max-width: ${CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH};
    
    &>*:not(${PreviewWrapper}) {
      margin-left: 19px;
      margin-right: 19px;
    }
`;

export const EmbedTabWrapper = styled.div`
  margin: 31px 0 0 0;
  max-width: 400px;
  padding-bottom: 30px;

  ${embedCodeWrapperTablet};
`;

export const LoaderWrapper = styled(Loader)`
  margin-top: 100px;
`;

export const InlineEmbed = styled.div``;

export const TypeSelection = styled.div`
  margin: 0 0 18px 0;
`;
